<script setup lang="ts">
import { Button } from "@/components/ui/button"

const props = defineProps<{ isLoading: boolean }>()

const emits = defineEmits<{
  onAnswer: [boolean]
}>()

const handleClick = (value: boolean) => {
  emits("onAnswer", value)
}
</script>

<template>
  <div class="flex justify-center gap-4">
    <Button
      class="flex min-w-[120px] gap-2 font-normal"
      variant="tertiary"
      :disabled="props.isLoading"
      @click="handleClick(false)"
    >
      <FaIcon icon="fa-solid fa-xmark" class="text-afgrey-600 h-4 w-4" />

      {{ $t("general.no") }}
    </Button>
    <Button
      class="flex min-w-[120px] gap-2 font-normal"
      variant="tertiary"
      :disabled="props.isLoading"
      @click="handleClick(true)"
    >
      <FaIcon icon="fa-solid fa-check" class="text-afgrey-600 h-4 w-4" />

      {{ $t("general.yes") }}
    </Button>
  </div>
</template>
